import { render, staticRenderFns } from "./DiscountManagement.vue?vue&type=template&id=ec03b85a&scoped=true"
import script from "./DiscountManagement.vue?vue&type=script&lang=js"
export * from "./DiscountManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/background/ddb.css?vue&type=style&index=0&id=ec03b85a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec03b85a",
  null
  
)

export default component.exports